import { useTranslation } from 'react-i18next';
import CustomModal from '../../../../../components/Modal/CustomModal';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import {
    DescriptionTittle,
    MarkerTitle,
    MealTimeTitle,
    PersonOutlinedTitle,
    QrTitle,
    ScheduleTitle,
} from '../../../../../components/buttons/IconButtons';
import {REQUEST_STATUS} from '../Model/Models';
import { GetQr, GetSummaryById } from '../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { QRCode } from 'react-qrcode-logo';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat,
    getFullName
} from '../../../../../Apis/functions';
import {SUB_VIEW_MODEL, TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER} from '../../../DiningOrders/Model/Models';
import NotInformation from "../../../../../components/NotInformation";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const RequestSummary = ({ item, open, onHide, activeStep, subview, qrContainerRef, handleDownloadQr }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState('');
    const [qrData, setQrData] = useState('');
    const isHistory = activeStep === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX || subview === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY;
    // Determines if the request is approved and valid based on multiple conditions:
    const isApprovedRequest =
        item?.approvalStatusId === REQUEST_STATUS.APPROVED.id &&
        item?.id &&
        isHistory ;
    const mealTimeName = isHistory ? data?.mealTimeName : item?.mealTimeName;//History Requests (Contractor/Supplier/Employee) || Active Requests()

    // Fetch summary data
    useEffect(() => {
         if (isApprovedRequest) {
            dispatch(GetQr(item?.id)).then(
                ({
                    payload: {
                        data: { data, success },
                    },
                }) => {
                    if (success) {
                        setQrData(data ? JSON.stringify(data) : null);
                    }
                },
            )
         }
        dispatch(GetSummaryById(item?.id)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success) {
                    setData(data);
                }
            },
        );
    }, [item, dispatch]);

    return (
        <CustomModal
            title={'diner_summary'}
            show={open}
            size='m'
            buttonConfirm='download'
            cancelButton={isApprovedRequest}
            confirmButton={isApprovedRequest}
            onConfirm={() => handleDownloadQr(data.id)}
            onHide={onHide}
        >
            <div className='row'>
                <div className={'col-12'}>
                    <CustomGenericTittleIconDataChip Icon={DescriptionTittle} title={'description'} />
                    <span className='ibl-description ibl-font-w-500 line-height'>{data?.description}</span>
                </div>
                <div className={'row mt-2'}>
                    <div className='col-6 mt-4 pl-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={ScheduleTitle}
                            showAvatar={false}
                            title={'order_date'}
                            name={
                                data?.createdAt
                                    ? getDateFormat(data.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                      : EMPTY_VALUES.DEFAULT
                            }
                            key={data?.id}
                        />
                    </div>

                    <div className='col-6 mt-4 pr-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={MealTimeTitle}
                            title={'meal_time'}
                            name={mealTimeName || EMPTY_VALUES.DEFAULT}
                            key={data?.id}
                            showAvatar={false}
                        />
                    </div>

                    <div className='col-6 mt-4 pl-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={ScheduleTitle}
                            showAvatar={false}
                            title={'serving_date'}
                            name={data?.servingDate ? getDateFormat(data?.servingDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT}
                            key={data?.id}
                        />
                    </div>
                    {isApprovedRequest && (
                        <div className='col-6 mt-4 pr-0'>
                            <CustomGenericTittleIconDataChip
                                Icon={MarkerTitle}
                                title={'diner'}
                                name={data?.cafeteriaName}
                                key={data?.id}
                                showAvatar={false}
                            />
                        </div>
                    )}
                </div>
                {isApprovedRequest && (
                    <div className={'col-12 mt-4'}>
                        <CustomGenericTittleIconDataChip Icon={QrTitle} title={'qr_code'} />
                        <div className='d-flex justify-content-center mt-3'>
                            {qrData ? (
                                <>
                                    <div className='vcard-container-modal' ref={qrContainerRef}>
                                        <QRCode value={qrData} size={300} renderAs='canvas' includeMargin={true} />
                                    </div>
                                </>
                            ) : <NotInformation text={t('no_qr_available')} card={true} />
                            }
                        </div>
                    </div>
                )}
                {data?.requestedById !== data?.userId && data?.requestedByName && (
                    <div className={'col-12 mt-4'}>
                        <CustomGenericTittleIconDataChip Icon={PersonOutlinedTitle} title={'requested_by_manager'} />
                        <span className='ibl-description ibl-font-w-500 line-height'>
                            {getFullName(
                                data?.requestedByName,
                                data?.requestedByLastName,
                                data?.requestedBySecondLastName,
                            )}
                        </span>
                    </div>
                )}
            </div>
        </CustomModal>
    );
};

export default RequestSummary;
